module.exports = __webpack_public_path__ + "static/media/WBN.93cded63.png";